
export const language: any ={
    OkLogout: "Có",
    CloseLogout: "Không",
    OkLeave: "Thoát",
    CloseLeave: "Hủy",
    LabelPolicy: "Chính sách xử lý thông tin cá nhân",
    AppName: "Hey! Cooker",
    OnOffNotification: "Bật/Tắt thông báo",
    LabelReceiveNotificationSuggestion: "Nhận thông báo đề xuất món ăn",
    LabelReceiveNotifyBreakfast: "Nhận đề xuất bữa sáng hàng ngày",
    LabelReceiveNotifyLunch: "Nhận đề xuất bữa trưa hàng ngày",
    LabelReceiveNotifyDinner: "Nhận đề xuất bữa tối hàng ngày",
    notification_history: "Lịch sử thông báo",
    readAll: "Đọc tất cả",
    no_notification: "Chưa có lịch sử thông báo nào",
    labelDisplayName: "Nhập tên hiển thị",
    placeholderDisplayName: "Nhập tối thiểu 4 ký tự, tối đa 20 ký tự",
    changeDisplayName: "Thay đổi tên hiển thị",
}

